import { gql } from "@apollo/client";

export const GET_ALL_USER = gql`
query Query($page: Int, $limit: Int, $filter: String, $sort: userSort, $search: String, $from: String, $to: String) {
  getAllUser(page: $page, limit: $limit, filter: $filter, sort: $sort, search: $search, from: $from, to: $to) {
    count
    data {
      id
      email
      userType
        verified
    ApprovePrivacyPolicy
      isActive
      createdAt
    }
  }
}
`

export const GET_ROLE_USER = gql`
query Query {
  me {
    id
    email
    mobile
    userType
    isActive
    createdAt
  firstName
  lastName
  documentType
  documentId
  documentFrontImage
  SellerId
  documentBackImage
  }
}
`
export const GET_S3_SIGN_URL = gql`
   query Query($type: String!, $name: String) {
  getPreSignedUrl(type: $type, name: $name)
}
`

export const GET_DASHBOARD_SUMMERY = gql`
query GetDashboardData($filter: DashboardFilterInput) {
  getDashboardData(filter: $filter) {
    totalShipments
    deliveredOrders
    deliveredPercentage
    revenue
    codRevenue
    prepaidRevenue
    statusWise {
      status
      count
    }
    stateWise {
      state
      count
    }
    paymentWise {
      paymentType
      count
    }
  }
}
`